module.exports = __webpack_public_path__ + "media/bootstrap-icons/brightness-alt-high-f6ede0cc.svg";